// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__kNkX7","modal":"Modal_modal__vLU4o","slide-down":"Modal_slide-down__IIY+w"};